import { LazyImage } from '@mr-yum/frontend-ui'
import { CollectionVenueCard } from 'components/Venue/shared'
import React from 'react'

import { LinkOrRoute } from './LinkOrRoute'

interface Props {
  name?: string
  description?: string
  areas: {
    image: string
    title: string
    venueSlug?: string
    url?: string
  }[]
}

export const VenueAreas = ({
  name,
  description = 'Where are you ordering from?',
  areas,
}: Props) => {
  return (
    <div className="mx-auto w-full max-w-[480px] px-2">
      <div className="flex min-h-screen flex-col pt-10 text-foreground">
        <div className="text-center my-heading-xs">{name}</div>
        <div className="my-12 flex max-h-40 w-full justify-center">
          <div className="text-center my-heading-md">{description}</div>
        </div>
        {areas.map(({ url, venueSlug, image, title }) => (
          <LinkOrRoute key={venueSlug || url} venueSlug={venueSlug} url={url}>
            <CollectionVenueCard
              image={
                <LazyImage src={image} alt={`${name} ${title}`} sizes="500px" />
              }
              title={title}
            />
          </LinkOrRoute>
        ))}
      </div>
    </div>
  )
}
